// removed by extract-text-webpack-plugin
module.exports = {"image":"src-pages-work-cityatlas----styles-module---image---1T2lM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/work/cityatlas/styles.module.css
// module id = 330
// module chunks = 278102253565233